<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">LED屏信息</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="LED名称" prop="Name">
            <el-input v-model="Name" placeholder="请输入名称"></el-input>
          </el-form-item>
          <el-form-item label="LED类型">
            <el-select v-model="LEDType" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in LEDTypeArr"
                :key="item.ItemKey"
                :label="item.Description"
                :value="item.ItemValue"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column prop="NUM_EQT" label="LED编号"></el-table-column>
              <el-table-column
                prop="NAME_EQT"
                label="LED名称"
              ></el-table-column>
              <el-table-column
                prop="IPAdd_EQT"
                label="IP地址"
              ></el-table-column>
              <el-table-column
                prop="ARENUM_EQT"
                label="所属区域"
                :formatter="RegionNumToNameConverter"
              >
              </el-table-column>
              <el-table-column prop="LedType" label="屏类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.LedType == 1">同步屏</span>
                  <span v-else-if="scope.row.LedType == 2">异步屏</span>
                </template>
              </el-table-column>
              <el-table-column prop="LEN_TPLEQT" label="长度"></el-table-column>
              <el-table-column
                prop="WIDTH_TPLEQT"
                label="宽度"
              ></el-table-column>
              <el-table-column prop="LedIndexNO" label="屏号"></el-table-column>
              <el-table-column prop="STATE_EQT" label="状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.STATE_EQT == 0" style="color:red;"
                    >离线</span
                  >
                  <span
                    v-else-if="scope.row.STATE_EQT == 1"
                    style="color:green;"
                    >在线</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >查看</el-button
                    >
                    <el-button
                      @click="editDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >编辑</el-button
                    >
                    <el-button
                      @click="deleteClick(scope.$index, scope.row)"
                      type="text"
                      size="small"
                      >删除</el-button
                    >
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
export default {
  name: "LedDeviceManagerView",
  controller: "UI",
  action: "LedDeviceManagerView",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      Name: "",
      LEDType: "",
      LEDTypeArr: [],
      EqRegionArr: [],
    };
  },
  created: function() {
    //LED类型
    this.getLEDType();
    //所属区域
    this.getRegionInfo();
  },
  mounted: function() {
    this.search();
    this.logInfo.ActionName = "LED屏信息查询";
    this.logInfo.LogMessage = "LED屏信息查询";
    this.logInfo.ModuleName = "LED系统";
    this.logInfo.PageName = "LED设备管理列表";
    this.addOperationLog();
  },
  methods: {
    RegionNumToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const RegionName = this.EqRegionArr.map((item) => {
        if (item.RegionNo == data) return item.RegionName;
      }).join("");
      if (RegionName == null || RegionName == "") {
        return data;
      }
      return RegionName;
    },
    getRegionInfo() {
      const RegionInfo = {
        EquipmentType: "Monitor",
        Longitude: 0.0,
        Latitude: 0.0,
      };
      new MyApis.RegionList()
        .GetRegionInfos(RegionInfo)
        .then((r) => {
          r = r.data.Data;
          this.EqRegionArr = r;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getLEDType() {
      this.config
        .getUValue("LEDSubSystem:LEDType", "")
        .then((d) => {
          this.LEDTypeArr = d.JValue;
        })
        .catch((e) => console.error(e));
    },
    search() {
      let searchInfo = {
        name: this.Name,
        Ledtype: this.LEDType === "" ? -1 : this.LEDType,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0,
      };
      new MyApis.TranResourcesApi()
        .GetItemPagingList(searchInfo)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
        })
        .catch((e) => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/led/UI/LedDeviceManagerEdit",
        query: {
          type: "add",
        },
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/led/ui/LedDeviceManagerEdit",
        query: { InfoId: row.ID, type: "query" },
      });
    },
    //编辑
    editDetail(index, row) {
      this.$router.push({
        path: "/plugin/led/ui/LedDeviceManagerEdit",
        query: { InfoId: row.ID, type: "edit" },
      });
    },
    //行删除
    deleteClick(index, row) {
      this.$confirm("此操作将永久删除该行数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          new MyApis.TranResourcesApi()
            .DeleteLedEquipment(row)
            .then((r) => {
              r = r.data.Data;
              if (r) {
                this.$message({
                  type: "success",
                  message: "删除成功!",
                });
                this.logInfo.ActionName = "LED屏信息删除";
                this.logInfo.LogMessage = "LED屏信息删除成功";
                this.logInfo.ModuleName = "LED系统";
                this.logInfo.PageName = "LED设备管理列表";
                this.addOperationLog();
              } else {
                this.$message({
                  type: "error",
                  message: "删除失败!",
                });
              }
              this.search();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 点击查询按钮
    onSearch() {
      if (new Date(this.EndTime) < new Date(this.BeginTime)) {
        this.$message.error("开始时间不能大于结束时间");
        return;
      }
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.CarParkName = "";
      this.Name = "";
      this.LEDType = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
